import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { KbItemListResponse, KbItemType } from '@medindex-webapi';

@Component({
  selector: 'app-helix-book-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemComponent {
  @Input() item: KbItemListResponse | null = null;

  getLink(item: KbItemListResponse): string {
    switch (item.type) {
      case KbItemType.Analyse:
        return `/kb/item/${item.hxid}`;
      case KbItemType.Disease:
        return `/kb/item/${item.id}`;
      case KbItemType.GeneticDictionary:
        return `/kb/dict/${item.title}`;
      default:
        return '';
    }
  }
}
